<div class="container">
  <h2>Cost Center</h2>
  <ul>
      <li>
          <a routerLink="cctr-definition" title="Definition of Cost Center">
              Definition of Cost
              Center
          </a>
      </li>
      <li><a routerLink="ccfacranges" title="Faculty Ranges">Faculty Ranges (by Org Unit)</a></li>
      <li>
          <a [routerLink]="['faclist']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
             title="Cost Center Faculty">
              Cost Center Faculty
          </a>
      </li>
      <li>
          <a [routerLink]="['buildinglist']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
             title="Buildings (Range 0001-0699)">
              Buildings (Range 0001-0699)
          </a>
      </li>
      <li>
          <a [routerLink]="['improvements']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
             title="Improvements (Range 0700-0899)">
              Improvements (Range
              0700-0899)
          </a>
      </li>
      <li>
          <a [routerLink]="['other']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"
             title="Other">Other (Range 0900-0999)</a>
      </li>
  </ul>
</div>